import { asset } from '@/lib/assets'
import React from 'react';
import Image from 'next/image';
import styles from './NavbarLogo.module.css';
import Link from 'next/link';

type NavbarLogoProps = {
  className?: string;
  href?: string;
  onClick?: () => void;
  /** @deprecated Logo is always the meritlens image; kept for call-site compatibility */
  dark?: boolean;
  priority?: boolean;
  'aria-label'?: string;
};

export const NavbarLogo: React.FC<NavbarLogoProps> = ({
  className = '',
  href = '/',
  onClick,
  priority = false,
  'aria-label': ariaLabel = 'meritlens home',
}) => {
  const logoImage = (
    <Image
      src={asset("/assets/Icons/meritlens-logo-light-large.png")}
      alt="meritlens"
      width={188}
      height={60}
      priority={priority}
      className={styles.logoImage}
    />
  );

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={`${styles.logoButton} ${className}`}
        aria-label={ariaLabel}
      >
        {logoImage}
      </button>
    );
  }

  if (href) {
    return (
      <Link href={href} className={`${styles.logoLink} ${className}`} aria-label={ariaLabel}>
        {logoImage}
      </Link>
    );
  }

  return <div className={className}>{logoImage}</div>;
};
